module.exports = __webpack_public_path__ + "img/ralphhagedorn.d925bbd6.svg";